import { type showShareStudyingStatsModalPayload, type INativeInteractor } from './nativeInteractor'

declare global {
  interface Window {
    callNativeFunction?: CallNativeInterface | null
  }
}

export declare interface CallNativeInterface {
  showSettingModal: () => void
  showSconnChargeModal: () => void
  showShareStudyingStatsModal: (payload: string) => void
  showHoldPointPage: () => void
  showCouponPage: () => void
  showServiceList: () => void
  serviceLogout: () => void
  openUrl: (url: string) => void
  showStoreProduct: (pdfId: string) => void
  getNativeToken: () => Promise<string | undefined>
  requestParentConsent: () => Promise<string | undefined>
  sendNicknameChangedResult: (nickname: string) => void
}

export class AosNativeInteractor implements INativeInteractor {
  showSettingModal() {
    this.getNativeInteractor()?.showSettingModal()
  }

  showSconnChargeModal() {
    this.getNativeInteractor()?.showSconnChargeModal()
  }

  showShareStudyingStatsModal(payload: showShareStudyingStatsModalPayload) {
    this.getNativeInteractor()?.showShareStudyingStatsModal(JSON.stringify(payload))
  }

  showHoldPointPage() {
    this.getNativeInteractor()?.showHoldPointPage()
  }

  showCouponPage() {
    this.getNativeInteractor()?.showCouponPage()
  }

  serviceLogout() {
    this.getNativeInteractor()?.serviceLogout()
  }

  openUrl(url: string) {
    this.getNativeInteractor()?.openUrl(url)
  }

  showServiceList() {
    this.getNativeInteractor()?.showServiceList()
  }

  async getNativeToken(): Promise<string | undefined> {
    try {
      return await this.requestNativeToken()
    } catch (e) {
      console.log(e)
    }
  }

  showStoreProduct(pdfId: string) {
    this.getNativeInteractor()?.showStoreProduct(pdfId)
  }

  private async requestNativeToken(): Promise<string | undefined> {
    return await new Promise((resolve, reject) => {
      const getToken = (token: string) => {
        resolve(token)
      }

      this.getNativeInteractor()?.getNativeToken()

      window.getNativeToken = getToken
    })
  }

  async requestParentConsent(): Promise<string | undefined> {
    try {
      return await this.requestIsParentConsent()
    } catch (e) {
      console.log(e)
    }
  }

  sendNicknameChangedResult(nickname: string) {
    this.getNativeInteractor()?.sendNicknameChangedResult(nickname)
  }

  private async requestIsParentConsent(): Promise<string | undefined> {
    return await new Promise((resolve, reject) => {
      const parentConsent = (isConsented: string | undefined) => {
        resolve(isConsented)
      }

      this.getNativeInteractor()?.requestParentConsent()

      window.requestParentConsent = parentConsent
    })
  }

  private getNativeInteractor(): CallNativeInterface | undefined | null {
    return window?.callNativeFunction ?? window?.top?.callNativeFunction
  }
}
